'use client';

import { CommunityEnum } from '@/app/types';
import { FeedContainer } from '../_components/FeedContainer';

export const ReferencePageClient = () => {
  return <FeedContainer exploreTab={CommunityEnum.PostReferences} />;
};
